
import { useEffect, useState } from "react";
import { _EcmDocument, _QualityInspectionProductItem, _QualityInspectionSpecialGarment, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { SelectQualityGarment } from "../../../QualityGarment/SelectQualityGarment";
import { QualityInspectionEspecialGarmentPropsList } from "./QualityInspectionEspecialGarmentPropsList";
import { PdfDocuments } from "../../../../../documents/PdfDocuments";
import { SingPanelEditor } from "../../../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { SelectQualityErrorTypes } from "../../../QualityErrors/SelectQualityErrorTypes";
import { SelectQualityErrorDetails } from "../../../QualityErrors/QualityErrorDetails/SelectQualityErrorDetails";

interface componentData {
    QualityInspectionProduct: any
}

export const QualityInspectionSpecialGarment = ({ QualityInspectionProduct }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityInspectionSpecialGarment)

    const modal = useModal("", MODAL_XL);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);
    const modalDocument = useModal("Solicitar flujo de firmas", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);

    const head = [
        { title: 'ID', property: 'IDQualityInspectionSpecialGarment', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Medidas', property: 'RenderList', visible: true },
        { title: 'Fecha de Revisión', property: 'ReviewDate', visible: true },
    ];

    useEffect(() => {
        if (QualityInspectionProduct?.IDQualityInspectionProduct) {
            getLista();
        }
    }, [QualityInspectionProduct?.IDQualityInspectionProduct])

    const renderGarments = (garments: any[]) => {
        if (!garments || garments.length === 0) return "N/P";

        const render = garments.map((medida, index) => {
            return `
            <div key="${index}">
                <strong>${medida.name} - </strong>
                <small>${medida.medido ? `${medida.medido} ${medida.measurementName ?? "N/A"}` : "N/A"}</small>
                <strong> - ${medida.satisfy}</strong>
            </div>
        `;
        });
        return render.join("");
    };

    const getLista = () => {
        const props = {
            IDQualityInspectionProduct: QualityInspectionProduct?.IDQualityInspectionProduct,
            State: 1
        };

        instance.getQualityInspectionSpecialGarmentCatalogPorPropiedades(props, null)
            .then((resp) => {
                resp.forEach(element => {
                    const values = element.DataBeanProperties;
                    let garments = [];

                    if (values.JSONQualityGarmentValues) {
                        try {
                            garments = JSON.parse(values.JSONQualityGarmentValues);
                        } catch (err) {
                            console.error("Error parseando JSONQualityGarmentValues:", err);
                        }
                    }

                    values.RenderList = renderGarments(garments);
                });

                setLista(resp);
            })
            .catch(err => {
                toast.error(err);
            });
    };


    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            IDQualityInspectionProduct: QualityInspectionProduct?.IDQualityInspectionProduct,
            State: 1,
            IDEmployee: _single.getAccountID(),
            ReviewDate: _single.getCurrenDate(),
            IDCustomer: QualityInspectionProduct?.IDCustomer,
            IDProduct: QualityInspectionProduct.IDProduct,
        });
        modal.open("Agregar Inspección de Cumplimiento de Medidas Finales");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Agregar Inspección de Cumplimiento de Medidas Finales") } },
            { titulo: 'Solicitar Aprobaciones', icono: 'mdi mdi-signature-text', visible: _single.canEdit(), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.IDDocument, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionSpecialGarment(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "ReviewDate", "IDCustomer", "Quantity", "IDQualityGarment",
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const validateDataSigned = () => {
        if (!signed.bean.IDSignPanel) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    }

    const signed = useDataBean(_EcmDocument);

    const createEcmDocumentForFlowControl = () => {

        const Obs = `Durante la inspección de Calidad del Proceso, para la produccion del producto, se presentaron los reprocesos con sus respectivas observaciones, danto como resultado un tiempo total de  en reprocesos`

        signed.instance.createEcmDocumentForFlowControl(signed.bean.IDSignPanel, _single.getAccountID(), Obs, null, null, null, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                if (resp.IDDocument > 0) {
                    signed.instance.fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, signed.bean.IDSignPanel, _single.getAccountID()).then(
                        (resp: any) => {
                            toast.success(resp);
                            console.log(resp)
                        }
                    ).catch(
                        err => {
                            toast.error("No se pudo iniciar proceso de firmas")
                        }
                    )
                    editaItem({ ...bean, IDDocument: resp.IDDocument, DocumentDate: resp.DocumentDate })
                } else {
                    toast.error("No se genero documentoa firmar")
                }
            }).catch(
                err => { toast.error(err) }
            )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('ReviewDate') ? 'has-error' : ''}`}>Fecha de Revisión</label>
                            <InputDate name="" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDCustomer') ? 'has-error' : ''}`}>Cliente</label>
                            <AccountEditor idAccount={bean.IDCustomer} label=" " onChange={(e) => { setBean({ ...bean, IDCustomer: e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                            <input type="number" value={bean.Quantity} onChange={(e) => {
                                const value = e.target.value ? parseInt(e.target.value) : null
                                setBean({ ...bean, Quantity: value })
                            }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDQualityGarment') ? 'has-error' : ''}`}>Prenda a Revisar</label>
                            <SelectQualityGarment idSelector={bean.IDQualityGarment} onChange={(e) => { setBean({ ...bean, IDQualityGarment: e }) }} label=" " />
                        </div>

                        {bean.IDQualityGarment &&
                            <div className="col-md-12">
                                <QualityInspectionEspecialGarmentPropsList idGarment={bean.IDQualityGarment} jsonProps={bean.JSONQualityGarmentValues} onChange={(e) => { setBean({ ...bean, JSONQualityGarmentValues: e }) }} />
                            </div>
                        }
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectQualityErrorTypes idSelector={bean.IDQualityErrorTypes} onChange={(e) => { setBean({ ...bean, IDQualityErrorTypes: e }) }} label="Tipo de Error" />
                                </div>
                                {bean.IDQualityErrorTypes &&
                                    <div className="col-md-6">
                                        <SelectQualityErrorDetails idSelector={bean.IDQualityErrorDetails} onChange={(e) => { setBean({ ...bean, IDQualityErrorDetails: e }) }} idErrorType={bean.IDQualityErrorTypes} label="Error" />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Observations') ? 'has-error' : ''}`} >Observaciones</label>
                            <textarea value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }} className="form-control" />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>

                <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { validateDataSigned() }}  >
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                        <SingPanelEditor idSelector={signed.bean.IDSignPanel} label=" " onChange={(e) => { signed.setBean({ ...signed.bean, "IDSignPanel": e }) }} />

                    </div>
                </Modal>

                <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                    <PdfDocuments documentLocation={bean.IDDocument} date={bean.DocumentDate} mnemonic="ECM" />
                </Modal>
            </div>
        </div>
    )
}